
  // Shim Vue HMR runtime for dev-compiled components loaded by a non-Vite host.
  // When a remote is served by a Vite dev server, Vue's SFC compiler injects HMR
  // hooks that reference __VUE_HMR_RUNTIME__. This global only exists on pages
  // served by Vite's client runtime. When a production host loads the remote,
  // the HMR calls would throw. This no-op shim prevents that.
  if (typeof __VUE_HMR_RUNTIME__ === 'undefined') {
    globalThis.__VUE_HMR_RUNTIME__ = { createRecord() {}, rerender() {}, reload() {} };
  }
  import {createInstance, loadRemote} from "@module-federation/runtime";
  
  
const __mfResolveGlobalKey = "__mf_init____mf__virtual/__mfe_internal__butlrDashboard__mf_v__runtimeInit__mf_v__.js__";
let __mfResolveState = globalThis[__mfResolveGlobalKey];
if (!__mfResolveState) {
  let initResolve, initReject;
  const initPromise = new Promise((re, rj) => {
    initResolve = re;
    initReject = rj;
  });
  __mfResolveState = globalThis[__mfResolveGlobalKey] = {
    initPromise,
    initResolve,
    initReject,
  };
  if (typeof window === 'undefined') {
    initResolve({
      loadRemote: function() { return Promise.resolve(undefined); },
      loadShare: function() { return Promise.resolve(undefined); },
    });
  }
}
const initResolve = __mfResolveState.initResolve;

  
const __mfCacheGlobalKey = "__mf_module_cache__";
globalThis[__mfCacheGlobalKey] ||= { share: {}, remote: {} };
globalThis[__mfCacheGlobalKey].share ||= {};
globalThis[__mfCacheGlobalKey].remote ||= {};
const __mfModuleCache = globalThis[__mfCacheGlobalKey];

  const initTokens = {}
  const shareScopeName = "default"
  const mfName = "__mfe_internal__butlrDashboard"
  let runtimeInstance
  let localSharedImportMapPromise
  let exposesMapPromise
  const shouldRetrySharedInitError = false && ((error) => {
    const message = String((error && error.message) || error || '');
    return message.includes('Importing a module script failed') ||
      message.includes('Failed to fetch') ||
      message.includes('Load failed') ||
      message.includes('Outdated Optimize Dep');
  });
  const waitSharedInitRetry = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  async function retrySharedInit(fn) {
    for (let attempt = 0; ; attempt++) {
      try {
        return await fn();
      } catch (e) {
        const canRetry = typeof shouldRetrySharedInitError === 'function' && shouldRetrySharedInitError(e);
        if (!canRetry || attempt >= 19) throw e;
        await waitSharedInitRetry(250);
      }
    }
  }

  async function getLocalSharedImportMap() {
    if (!localSharedImportMapPromise) {
      localSharedImportMapPromise = retrySharedInit(() => import("virtual:mf-localSharedImportMap:__mfe_internal__butlrDashboard"))
        .catch((e) => { localSharedImportMapPromise = undefined; throw e; });
    }
    return localSharedImportMapPromise
  }

  async function getExposesMap() {
    if (!exposesMapPromise) {
      exposesMapPromise = retrySharedInit(() => import("virtual:mf-exposes:__mfe_internal__butlrDashboard__remoteEntry-_hash_"))
        .then((mod) => mod.default ?? mod)
        .catch((e) => { exposesMapPromise = undefined; throw e; });
    }
    return exposesMapPromise
  }

  async function init(shared = {}, initScope = []) {
    const {usedShared, usedRemotes} = await getLocalSharedImportMap()
    if (__mfModuleCache.share["react"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/react/index.js");
        const exportModule = false && "react" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react"] = exportModule;
      }
if (__mfModuleCache.share["react-dom"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/react-dom/index.js");
        const exportModule = false && "react-dom" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react-dom"] = exportModule;
      }
if (__mfModuleCache.share["@apollo/client"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/@apollo/client/index.js");
        const exportModule = false && "@apollo/client" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@apollo/client"] = exportModule;
      }
if (__mfModuleCache.share["@auth0/auth0-react"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/@auth0/auth0-react/dist/auth0-react.esm.js");
        const exportModule = false && "@auth0/auth0-react" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@auth0/auth0-react"] = exportModule;
      }
if (__mfModuleCache.share["@reduxjs/toolkit"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js");
        const exportModule = false && "@reduxjs/toolkit" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@reduxjs/toolkit"] = exportModule;
      }
if (__mfModuleCache.share["@statsig/react-bindings"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/@statsig/react-bindings/src/index.js");
        const exportModule = false && "@statsig/react-bindings" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@statsig/react-bindings"] = exportModule;
      }
if (__mfModuleCache.share["dayjs"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/dayjs/dayjs.min.js");
        const exportModule = false && "dayjs" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["dayjs"] = exportModule;
      }
if (__mfModuleCache.share["graphql"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/graphql/index.mjs");
        const exportModule = false && "graphql" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["graphql"] = exportModule;
      }
if (__mfModuleCache.share["i18next"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/i18next/dist/esm/i18next.js");
        const exportModule = false && "i18next" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["i18next"] = exportModule;
      }
if (__mfModuleCache.share["react-hot-toast"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/react-hot-toast/dist/index.mjs");
        const exportModule = false && "react-hot-toast" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react-hot-toast"] = exportModule;
      }
if (__mfModuleCache.share["react-i18next"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/react-i18next/dist/es/index.js");
        const exportModule = false && "react-i18next" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react-i18next"] = exportModule;
      }
if (__mfModuleCache.share["react-router-dom"] === undefined) {
        const mod = await import("/home/runner/work/butlr-dashboard/butlr-dashboard/node_modules/react-router-dom/dist/index.mjs");
        const exportModule = false && "react-router-dom" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react-router-dom"] = exportModule;
      }
    const runtimeOptions = {
      name: mfName,
      remotes: usedRemotes,
      shared: usedShared,
      plugins: [],
      shareStrategy: 'version-first'
    };
    if (!runtimeInstance) {
      runtimeInstance = createInstance(runtimeOptions);
    } else {
      runtimeInstance.initOptions(runtimeOptions);
    }
    const initRes = runtimeInstance;
    // handling circular init calls
    var initToken = initTokens[shareScopeName];
    if (!initToken)
      initToken = initTokens[shareScopeName] = { from: mfName };
    if (initScope.indexOf(initToken) >= 0) return;
    initScope.push(initToken);
    initRes.initShareScopeMap('default', shared);
    initResolve(initRes)
    try {
      await retrySharedInit(async () => {
        await Promise.all(await initRes.initializeSharing('default', {
          strategy: 'version-first',
          from: "build",
          initScope
        }));
      });
    } catch (e) {
      console.error('[Module Federation]', e)
    }
    return initRes
  }

  async function getExposes(moduleName) {
    const exposesMap = await getExposesMap()
    if (!(moduleName in exposesMap)) throw new Error(`[Module Federation] Module ${moduleName} does not exist in container.`)
    return (exposesMap[moduleName])().then(res => () => res)
  }
  export {
      init,
      getExposes as get
  }
  